import { usePaywallCustomizationContext } from "@circle-react/components/Paywalls/Checkout/CheckoutPage/CheckoutDescription/PaywallCustomization/PaywallCustomizationProvider";
import type { PaywallCustomization } from "@circle-react/types";
import type { PropsWithChildren } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

interface CustomizationLineProps {
  className?: string;
  feature: "benefits" | "testimonials";
}

export const isBenefitsEnabled = (
  paywallCustomization?: PaywallCustomization,
) => Boolean(paywallCustomization?.benefit_properties?.enabled);
export const isTestimonialsEnabled = (
  paywallCustomization?: PaywallCustomization,
) => Boolean(paywallCustomization?.testimonial_properties?.enabled);

export const CustomizationLine = ({
  children,
  feature,
  className,
}: PropsWithChildren<CustomizationLineProps>) => {
  const validators = {
    benefits: isBenefitsEnabled,
    testimonials: isTestimonialsEnabled,
  };

  const validator = validators[feature];
  const { paywallCustomization } = usePaywallCustomizationContext();

  if (!validator || !validator(paywallCustomization)) {
    return null;
  }

  return (
    <div
      className={classNames(
        "flex flex-col gap-y-8 w-full md:w-[540px]",
        className,
      )}
    >
      {children}
    </div>
  );
};
